// eslint-disable-next-line import/prefer-default-export
export const colorPallete = ['#2E9E5E', '#38EB85', '#EB742D', '#0E539E', '#2181EB', '#592EB3', '#2D33BD', '#305CA5', '#2D96BD', '#12B0A4'];
export const colorPalleteBlue = ['#2E9E5E', '#38EB85', '#EB742D', '#0E539E', '#2181EB'];
